<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col sm="12">
                        <h1 class="md-display-2 white--text">{{ $t('headings.Sign up') }}</h1>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col sm="6">

                        <v-card

                                class="mx-auto cta-card"
                                flat
                        >
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="headline primary--text">{{ $t('headings.Individuals') }}</v-list-item-title>
                                    <v-list-item-subtitle class="font-weight-bold subtitle-1">{{ $t('headings.Get lost kit back') }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-img
                                    :src="pic3"
                                    height="194"
                                    class="cta-card-img"
                            ></v-img>

                            <v-card-text class="subtitle-1">
                              <p>{{ $t("Sign up as an individual if you wish to buy tags for yourself, friends, family, dependants and anyone we have not mentioned!") }}</p>

                              <v-btn tile block elevation="0" color="primary" @click="navigate('sign-up-individual')">
                                {{ $t('buttons.Sign up as individual') }}
                              </v-btn>

                              <IndividualsSummary/>

                              <IndividualsContent />

                            </v-card-text>

                            <v-card-actions>
                                <v-btn tile elevation="0" color="primary" @click="navigate('sign-up-individual')">
                                    {{ $t('buttons.Sign up as individual') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>

                    <v-col sm="6">
                        <v-card
                                class="mx-auto cta-card"
                                flat
                        >
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="headline primary--text">{{ $t('headings.Organisations') }}</v-list-item-title>
                                    <v-list-item-subtitle class="font-weight-bold subtitle-1">{{ $t('headings.Get to grips with lost property') }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-img
                                    :src="pic4"
                                    height="194"
                                    class="cta-card-img"
                            ></v-img>

                            <v-card-text class="subtitle-1">
                              <p>{{ $t("Sign up as an organisation to start scanning our Smart tags") }}.</p>

                              <v-btn tile block elevation="0" color="primary" @click="navigate('sign-up-organisation')">
                                {{ $t('buttons.Sign up organisation') }}
                              </v-btn>

                              <OrganisationsSummary />
                              <OrganisationsContent />
                            </v-card-text>

                            <v-card-actions>
                                <v-btn tile elevation="0" color="primary" @click="navigate('sign-up-organisation')">
                                    {{ $t('buttons.Sign up organisation') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import IndividualsSummary from "./IndividualsSummary"
    import IndividualsContent from "./IndividualsContent"
    import OrganisationsSummary from "./OrganisationsSummary"
    import OrganisationsContent from "./OrganisationsContent"

    let pic3 = require('@/assets/IMG_2776.jpg')
    let pic4 = require('@/assets/IMG_3300.jpg')

    import Footer from './Footer'
    import {i18n} from "../i18n";
    import {mapState} from "vuex";

    export default {
        name: "Register",
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Sign up'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('Sign up as an individual if you wish to buy tags for yourself, friends, family, dependants and anyone we have not mentioned!') }
            ]
          }
        },
        components: {
          IndividualsSummary,
          IndividualsContent,
          OrganisationsSummary,
          OrganisationsContent,
          'Footer': Footer
        },
        data () {
            return {
                pic3: pic3,
                pic4: pic4
            }
        },
        mounted () {

            this.$gtag.pageview({
                page_path: '/register'
            })

            document.getElementById("scrolling-content").scrollTop = 0

            window.prerenderReady = true;
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            navigate(routeName) {
                this.$router.push({name: routeName})
            }
        },
        computed: {
          ...mapState({
            brand: state => state.brand
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
    }
</script>

<style scoped>
    .cta-card {
        border-radius: 15px !important;
        border: none !important;
    }
    .v-card__actions {
        padding: 16px;
        justify-content: flex-end;
    }
</style>
